import React, { useState } from 'react';
import { supabase } from '../supabase';

const GROQ_KEY = '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';
const UNSPLASH_KEY = 'pw-iXT14tgtV6W1f4JDWs9rcVbKocLWXEQslrf7vw1M';

const CUISINES = ['Казахская', 'Русская', 'Итальянская', 'Азиатская', 'Средиземноморская', 'Американская', 'Французская', 'Мексиканская'];

export default function Generate() {
  const [title, setTitle] = useState('');
  const [cuisine, setCuisine] = useState('Казахская');
  const [tags, setTags] = useState('');
  const [loading, setLoading] = useState(false);
  const [log, setLog] = useState<string[]>([]);
  const [result, setResult] = useState<any>(null);

  const addLog = (msg: string) => setLog(prev => [...prev, msg]);

  const searchImage = async (query: string) => {
    try {
      const url = `https://api.unsplash.com/search/photos?query=${encodeURIComponent(query + ' food')}&per_page=1&orientation=landscape`;
      const res = await fetch(url, { headers: { 'Authorization': `Client-ID ${UNSPLASH_KEY}` } });
      const data = await res.json();
      return data.results?.[0]?.urls?.regular || null;
    } catch { return null; }
  };

  const generate = async () => {
    if (!title) { alert('Введите название рецепта'); return; }
    setLoading(true);
    setLog([]);
    setResult(null);

    try {
      addLog(`⏳ Генерирую рецепт: ${title}...`);
      const response = await fetch('https://api.groq.com/openai/v1/chat/completions', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${GROQ_KEY}` },
        body: JSON.stringify({
          model: 'llama-3.3-70b-versatile',
          max_tokens: 1500,
          messages: [{
            role: 'user',
            content: `Создай рецепт "${title}" (кухня: ${cuisine}) в формате JSON. Верни ТОЛЬКО JSON без markdown:
{
  "title": "${title}",
  "description": "краткое описание",
  "cooking_time_minutes": число,
  "difficulty": "easy или medium или hard",
  "base_servings": число,
  "ingredients": [{"name": "продукт", "quantity": число, "unit": "г или мл или шт", "is_required": true, "is_spice": false}],
  "steps": ["шаг 1", "шаг 2"]
}`
          }],
        }),
      });
      const data = await response.json();
      if (data.error) throw new Error(data.error.message);
      const content = data.choices?.[0]?.message?.content || '';
      const recipe = JSON.parse(content.replace(/```json|```/g, '').trim());
      addLog(`✅ Рецепт сгенерирован (${recipe.ingredients.length} ингредиентов)`);

      addLog(`🔍 Ищу фото...`);
      const imageUrl = await searchImage(title);
      addLog(imageUrl ? `✅ Фото найдено` : `✗ Фото не найдено`);

      addLog(`💾 Сохраняю в БД...`);
      const { data: recipeData } = await supabase.from('recipes').insert({
        title: recipe.title,
        description: recipe.description,
        cooking_time_minutes: recipe.cooking_time_minutes,
        difficulty: recipe.difficulty,
        base_servings: recipe.base_servings,
        status: 'published',
        is_local: false,
        media_urls: imageUrl ? [imageUrl] : [],
      }).select().single();

      if (recipeData) {
        for (const ing of recipe.ingredients) {
          const { data: product } = await supabase.from('products').select('id, is_spice').ilike('name', `%${ing.name}%`).maybeSingle();
          if (product) {
            await supabase.from('recipe_ingredients').insert({
              recipe_id: recipeData.id, product_id: product.id,
              quantity: ing.quantity, unit: ing.unit,
              is_required: ing.is_required, is_spice: product.is_spice || ing.is_spice,
              weight: ing.is_required ? 8 : 4,
            });
          }
        }
        for (let i = 0; i < recipe.steps.length; i++) {
          await supabase.from('recipe_steps').insert({ recipe_id: recipeData.id, step_order: i + 1, instruction: recipe.steps[i] });
        }
        const tagList = tags.split(',').map(t => t.trim()).filter(Boolean);
        tagList.push(cuisine);
        for (const tagName of tagList) {
          const { data: tag } = await supabase.from('tags').select('id').eq('name', tagName).maybeSingle();
          if (tag) await supabase.from('recipe_tags').insert({ recipe_id: recipeData.id, tag_id: tag.id });
        }
        setResult(recipeData);
        addLog(`🎉 Рецепт "${title}" успешно добавлен! ID: ${recipeData.id}`);
      }
    } catch (e: any) {
      addLog(`❌ Ошибка: ${e.message}`);
    }
    setLoading(false);
  };

  return (
    <div>
      <h1 style={s.title}>✨ ИИ Генерация рецептов</h1>

      <div style={s.card}>
        <div style={s.row}>
          <div style={s.field}>
            <label style={s.label}>Название рецепта *</label>
            <input style={s.input} value={title} onChange={e => setTitle(e.target.value)} placeholder="Например: Куырдак" />
          </div>
          <div style={s.field}>
            <label style={s.label}>Кухня</label>
            <select style={s.input} value={cuisine} onChange={e => setCuisine(e.target.value)}>
              {CUISINES.map(c => <option key={c} value={c}>{c}</option>)}
            </select>
          </div>
        </div>
        <div style={s.field}>
          <label style={s.label}>Теги (через запятую)</label>
          <input style={s.input} value={tags} onChange={e => setTags(e.target.value)} placeholder="Обед, Основное, Мясо" />
        </div>
        <button style={{ ...s.btn, opacity: loading ? 0.6 : 1 }} onClick={generate} disabled={loading}>
          {loading ? 'Генерирую...' : '✨ Сгенерировать и добавить'}
        </button>
      </div>

      {log.length > 0 && (
        <div style={s.logCard}>
          {log.map((line, i) => <div key={i} style={s.logLine}>{line}</div>)}
        </div>
      )}

      {result && (
        <div style={{ ...s.card, borderColor: '#2ECC71' }}>
          <p style={{ color: '#2ECC71', fontWeight: 600 }}>✅ Рецепт добавлен: {result.title}</p>
          <p style={{ color: '#888', fontSize: 13 }}>ID: {result.id} · {result.cooking_time_minutes} мин · {result.difficulty}</p>
        </div>
      )}
    </div>
  );
}

const s: Record<string, React.CSSProperties> = {
  title: { fontSize: 24, fontWeight: 700, color: '#222', marginBottom: 24 },
  card: { backgroundColor: '#fff', borderRadius: 12, padding: 24, marginBottom: 16, boxShadow: '0 1px 4px rgba(0,0,0,0.06)', border: '1px solid #eee' },
  row: { display: 'flex', gap: 16, marginBottom: 12 },
  field: { flex: 1, display: 'flex', flexDirection: 'column', gap: 6 },
  label: { fontSize: 13, fontWeight: 600, color: '#555' },
  input: { padding: '10px 14px', borderRadius: 8, border: '1px solid #eee', fontSize: 14, outline: 'none' },
  btn: { backgroundColor: '#2ECC71', color: '#fff', border: 'none', borderRadius: 10, padding: '12px 24px', fontSize: 15, fontWeight: 600, cursor: 'pointer', marginTop: 8 },
  logCard: { backgroundColor: '#1a1a1a', borderRadius: 12, padding: 20, marginBottom: 16 },
  logLine: { color: '#aaa', fontSize: 13, marginBottom: 4, fontFamily: 'monospace' },
};